import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import _ from "lodash";
import axios from "axios";
import { useErrMsg } from "hooks";

export const useLogout = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const getErrMsg = useErrMsg();
  return useMemo(
    () => async () => {
      try {
        await axios.post("/api/v1/logout");
        navigate("/");
      } catch (err) {
        const errCode = _.get(err, "response.data.code");
        enqueueSnackbar(getErrMsg(errCode), {
          variant: "error",
        });
      }
    },
    [navigate, enqueueSnackbar, getErrMsg]
  );
};
